import { Card } from 'sections/Benefits/types';

export const cards: Card[] = [
  {
    id: 1,
    icon: 'icon-ocean.png',
    alt: 'Ocean tracking system icon',
    title: 'Ocean visibility',
    description: 'Get complete shipment information: current container location, all the related events, ETA, predictive ETA, and more.',
  },
  {
    id: 2,
    icon: 'icon-quarter.png',
    alt: 'Superior Tracking System',
    title: 'Superior data quality',
    description: 'SeaRates integrates multiple data sources to provide accurate and trustworthy international ocean freight information.',
  },
  {
    id: 3,
    icon: 'icon-planet.png',
    alt: 'Global Tracking System Icon',
    title: 'Global outreach',
    description: 'Boost your brand with a Branded Page and offer your customers superior service to increase customer engagement and promote your business globally.',
  },
  {
    id: 4,
    icon: 'icon-link.png',
    alt: 'DFA tracking system icon',
    title: 'DFA Premium add-in',
    description: 'Gain access to the tracking module and use it as a lead generation tool by becoming a premium member of DFA.',
  },
];